import { Pipe, PipeTransform } from '@angular/core';
import { search } from 'fast-fuzzy';
import { MenuGroupData } from '../menu-group/menu-group.component';
import { UserAccessService } from '../../../../../user/access/user-access.service';

const FUZZY_SEARCH_OPTS_DEFAULT = { ignoreCase: true, threshold: 0.85 };

@Pipe({ name: 'searchMenu', pure: true })
export class SearchMenuPipe implements PipeTransform {
  constructor(private accessService: UserAccessService) {}

  transform(groups: MenuGroupData[], query: string): MenuGroupData[] {
    if (!query) return groups;

    return groups.reduce<MenuGroupData[]>((outcome, group) => {
      const mapColor =
        group.data.mapColor?.filter(
          (el) =>
            this.accessService.userHasAccess(el.featureConst) &&
            !!search(
              query,
              [
                el.featureName,
                el.featureConst,
                el.tooltip?.headerText || '',
                el.tooltip?.text || '',
              ],
              FUZZY_SEARCH_OPTS_DEFAULT
            ).length
        ) ?? null;

      const charts =
        group.data.charts?.filter(
          (el) =>
            this.accessService.userHasAccess(el.featureConst) &&
            !!search(
              query,
              [
                el.toggleTitle,
                el.chartName,
                el.tooltip?.headerText || '',
                el.tooltip?.text || '',
              ],
              FUZZY_SEARCH_OPTS_DEFAULT
            ).length
        ) ?? null;

      const places =
        group.data.places?.filter((el) => {
          // Pick the right label field depending on the current type
          const label = 'featureName' in el ? el.featureName : el.toggleTitle;

          const candidates = [
            label,
            el.featureConst,
            el.tooltip?.headerText ?? '',
            el.tooltip?.text ?? '',
          ];

          return (
            this.accessService.userHasAccess(el.featureConst) &&
            !!search(query, candidates, FUZZY_SEARCH_OPTS_DEFAULT).length
          );
        }) ?? null;

      const hasContent =
        mapColor?.length! > 0 || charts?.length! > 0 || places?.length! > 0;
      if (!hasContent) {
        return outcome;
      }

      outcome.push({
        ...group,
        data: { mapColor, charts, places },
      });

      return outcome;
    }, []);
  }
}
